/**
 * Utility functions for parsing and formatting change history values
 */

/**
 * Safely parse JSON value, return original if not valid JSON
 */
export const parseJsonValue = value => {
    if (value === null || value === undefined) return null
    if (typeof value === 'object') return value

    try {
        return JSON.parse(value)
    } catch {
        return value
    }
}

/**
 * Determine the type of change based on field name
 */
export const getChangeType = field => {
    if (!field) return 'unknown'

    if (field === 'booster_added') return 'booster_added'
    if (field === 'booster_removed') return 'booster_removed'
    if (field.match(/^booster_\d+_priority$/)) return 'booster_priority'
    if (field === 'pattern_created') return 'pattern_created'
    if (field.match(/^pattern_\d+_conceptual_label_added$/)) return 'conceptual_label_added'
    if (field.match(/^pattern_\d+_conceptual_label_removed$/)) return 'conceptual_label_removed'
    if (field.match(/^\d+_color_id$/)) return 'category_color'
    if (field.match(/^\d+_/)) return 'category_field'
    if (field === 'color_id') return 'color'
    if (field === 'question_type') return 'question_type'
    if (field === 'type') return 'type'

    return 'default'
}

/**
 * Extract ID from field name patterns like "123_field_name" or "booster_123_priority"
 */
export const extractIdFromField = (field, pattern = 'prefix') => {
    if (!field) return null

    if (pattern === 'prefix') {
        // Matches "123_field_name"
        const match = field.match(/^(\d+)_/)
        return match ? Number(match[1]) : null
    }

    if (pattern === 'booster') {
        // Matches "booster_123_priority"
        const match = field.match(/^booster_(\d+)_/)
        return match ? Number(match[1]) : null
    }

    if (pattern === 'pattern') {
        // Matches "pattern_123_conceptual_label_added"
        const match = field.match(/^pattern_(\d+)_/)
        return match ? Number(match[1]) : null
    }

    return null
}

/**
 * Normalize field name for display
 */
export const normalizeFieldName = field => {
    if (!field) return ''

    if (field === 'grading_reference_content') return 'grading reference content'
    if (field === 'text') return 'content'
    if (field === 'color_id') return 'color'
    if (field === 'question_type') return 'question type'
    if (field === 'parent_id') return 'parent'
    if (field === 'depends_on') return 'dependent question'
    if (field === 'weight') return 'weight'
    if (field === 'word_limit') return 'word limit'
    if (field === 'type') return 'type'

    return field
}

/**
 * Format boolean value for display
 */
export const formatBooleanValue = value => {
    if (value === null || value === undefined) return 'None'
    if (value === 'true' || value === true) return 'Yes'
    if (value === 'false' || value === false) return 'No'
    return String(value)
}


